<template>
  <div class="w-100">
    <proa-card class="h-100 d-flex flex-column" no-padding>
      <template v-slot:header>
        <div class="d-flex justify-content-between align-items-center">
          <proa-back-button
            @onClick="onClickBackButton"
          />
          <proa-heading detail>{{ $t('pages.management.basicInformation.licensePlan') }}</proa-heading>
          <div/>
        </div>
      </template>
      <div class="license-plan-content">
        <table class="table-attributes">
          <tbody>
            <tr>
              <th>{{ $t('models.licensedPlan.attributes.planName') }}</th>
              <td>
                <span class="mr-3">{{ currentLicensedPlan.planName }}</span>
                <span>{{ currentLicensedPlan.price | currencyJPY }} / {{ $t('common.month') }}</span>
              </td>
            </tr>
            <tr>
              <th>{{ $t('models.licensedPlan.attributes.maxUsers') }}</th>
              <td>
                <span>{{ currentLicensedPlan.maxUsers + $t('common.person') }}</span>
                <span v-if="currentSeatTotalUsersCount"> ＋ {{ currentSeatTotalUsersCount + $t('common.person') }}</span>
              </td>
            </tr>
            <tr>
              <th>{{ $t('models.licensedPlan.attributes.maxGroups') }}</th>
              <td>{{ currentLicensedPlan.maxGroups || $t('common.unlimited') }}</td>
            </tr>
            <tr>
              <th>{{ $t('models.licensedPlan.attributes.maxFileSize') }}</th>
              <td>{{ currentLicensedPlan.maxFileSize + $t('common.mb') }}</td>
            </tr>
            <tr>
              <th>{{ $t('models.licensedPlan.attributes.maxStoreDuration') }}</th>
              <td>{{ currentLicensedPlan.maxStoreDuration + $t('common.months') }}</td>
            </tr>
            <template v-if="currentLicensedPlan.contractType !== 'free'">
              <!-- TODO: 有料ライセンス関連の情報 -->
            </template>
          </tbody>
        </table>
      </div>
      <div v-if="currentLicensedPlan.planType !== 'admin' && !isMaintenaceMode" class="license-plan-card-footer">
        <proa-button
          class="default-button-width"
          @click.native="onClickChangeLicensePlan"
        >
          {{ $t('pages.management.basicInformation.changeLicensePlan') }}
        </proa-button>
      </div>
    </proa-card>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import RoomPlanMaster from '@/store/models/admin/RoomPlanMaster'
import SeatPlanMaster from '@/store/models/admin/SeatPlanMaster'

export default {
  name: 'IndexManagementLicensePlan',
  computed: {
    currentSeatTotalUsersCount: function() {
      return this.currentLicensedPlan.seatPlanMasterIds.map(seatPlanMasterId => {
        return this.seatPlanMasters.filter((seatPlanMaster) => seatPlanMasterId == seatPlanMaster.id)[0]?.maxSeats
      }).filter((v) => v).reduce((a, b) => a + b, 0)
    },
    roomPlanMasters: function() {
      return RoomPlanMaster.all()
    },
    seatPlanMasters: function() {
      return SeatPlanMaster.all()
    },
    ...mapGetters({
      currentLicensedPlan: 'auth/currentLicensedPlan'
    })
  },
  data(){
    return {
      // NOTE: 初期状態をtrueにしておきデータ取得前に描画されないようにしておく
      isMaintenaceMode: true
    }
  },
  methods: {
    onClickBackButton: function() {
      this.$router.push({ name: 'management' })
    },
    onClickChangeLicensePlan: function() {
      this.$router.push({ name: 'editManagementLicensePlan', params: { returnPath: this.$route.path.slice(1) } })
    },
    ...mapActions({
      apiGetRoomPlanMasters: 'entities/roomPlanMasters/index',
      apiGetSeatPlanMasters: 'entities/seatPlanMasters/index',
      apiGetSystemManage: 'systemManage/show'
    })
  },
  async created() {
    this.isMaintenaceMode = await this.apiGetSystemManage()
    this.apiGetRoomPlanMasters()
    this.apiGetSeatPlanMasters()
  }
}
</script>

<style scoped lang="scss">
@import "@/styles/variables";
@import "@/styles/mediaquery";

.license-plan-content {
  flex-grow: 1;
  height: 100%;
  display: flex;
  flex-direction: column;

  .table-attributes {
    width: 100%;

    tr {
      display: block;
      border-bottom: 1px solid $light-border-color;
      padding: 15px 20px;

      @include mq(md) {
        display: table-row;
        border-bottom: 1px solid $dark-border-color;
        padding: 0;
      }
    }

    th {
      display: block;
      width: 100%;
      padding: 0;
      font-weight: 600;

      @include mq(md) {
        display: table-cell;
        width: 1px;
        white-space: nowrap;
        padding: 20px 50px 20px 20px;
      }
    }

    td {
      display: block;
      width: 100%;
      padding: 0;
      word-break: break-all;

      @include mq(md) {
        display: table-cell;
        width: auto;
        padding: 20px 20px 20px 0;
      }

      &.assets-column {
        text-align: right;
        padding-right: 20px;
      }
    }
  }
}

.license-plan-card-footer {
  display: flex;
  justify-content: flex-end;
  padding: 20px;
  border-top: 1px solid $dark-border-color;
}
</style>
